<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="pb-0">
        <v-tabs v-model="tabs" center-active fixed-tabs>
          <v-tab>일간</v-tab>
          <v-tab>월간</v-tab>
          <v-tab>연간</v-tab>
        </v-tabs>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pb-0" cols="6">
        <v-select outlined solo dense hide-details :items="comboList2" v-model="select2"></v-select>
      </v-col>
      <v-col cols="6">
        <v-select outlined solo dense hide-details :items="comboList" v-model="select"></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="py-0" cols="12">
        <date-picker :date="nowDate"></date-picker>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="py-0 d-inline-flex justify-end align-center">
        <v-btn outlined class="mx-5 default-btn" small @click="getData">조회</v-btn>
        <v-btn outlined class="mr-5 excel_down" small @click="excelDown">엑셀다운로드</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-tabs-items v-model="tabs">
          <v-tab-item>
            <v-row class="mx-1">
              <v-col class="chart-header-bg px-5 d-flex justify-space-between">
                일 누적 발전량
                <span class="text-caption">
                  <span class="big_txt">{{dailyP}}</span>
                  kWh
                </span>
              </v-col>
            </v-row>
            <v-row>
              <v-chart style="width:100%;height: 200px;" :option="chartOption"></v-chart>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-row>
              <v-chart style="width:100%;height: 200px;" :option="chartOption"></v-chart>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-row>
              <v-chart style="width:100%;height: 200px;" :option="chartOption"></v-chart>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
    <real-grid
      ref="tempGrid"
      class="mt-1 mb-5 w-full"
      :options="grid.gridOption"
      :fields="grid.gridFields"
      :columns="grid.gridColumns"
      :height="grid.height"
    ></real-grid>
  </v-container>
</template>

<script>
import { getWorkTrend } from '@/api/ess/siteWork'
import day from 'dayjs'
import DatePicker from '@/components/monitoring/DatePicker'
import RealGrid from '@/components/grid/Realgrid'

import { CanvasRenderer } from 'echarts/renderers'
import { BarChart, GaugeChart, LineChart } from 'echarts/charts'
import {
  DataZoomComponent,
  ToolboxComponent,
  GridComponent,
  VisualMapComponent,
  TimelineComponent,
  CalendarComponent,
  TooltipComponent
} from 'echarts/components'
import VChart, { THEME_KEY } from 'vue-echarts'
import { use } from 'echarts/core'

use([
  CanvasRenderer,
  BarChart,
  GaugeChart,
  LineChart,
  DataZoomComponent,
  ToolboxComponent,
  GridComponent,
  VisualMapComponent,
  TimelineComponent,
  CalendarComponent,
  TooltipComponent
])

export default {
  components: {
    DatePicker,
    VChart,
    RealGrid
  },
  provide: {
    [THEME_KEY]: 'light'
  },
  props: {
    site_id: { type: String, default: '' },
    essData: { type: [Object, Object], default: undefined }
  },
  data() {
    return {
      tabs: 0,
      comboList2: [
        {
          text: '태양광 인버터',
          value: 'PVPCS'
        },
        {
          text: 'ESS PCS',
          value: 'EPCS'
        },
        {
          text: '계통',
          value: 'GRID'
        }
      ],
      select2: 'PVPCS',
      select: '',
      tabValue: [
        {
          series: [
            '05:00',
            '05:20',
            '05:40',
            '06:00',
            '06:20',
            '06:40',
            '07:00',
            '07:20',
            '07:40',
            '08:00',
            '08:20',
            '08:40',
            '09:00',
            '09:20',
            '09:40',
            '10:00',
            '10:20',
            '10:40',
            '11:00',
            '11:20',
            '11:40',
            '12:00',
            '12:20',
            '12:40',
            '13:00',
            '13:20',
            '13:40',
            '14:00',
            '14:20',
            '14:40',
            '15:00',
            '15:20',
            '15:40',
            '16:00',
            '16:20',
            '16:40',
            '17:00',
            '17:20',
            '17:40',
            '18:00',
            '18:20',
            '18:40',
            '19:00',
            '19:20',
            '19:40',
            '20:00',
            '20:20',
            '20:40',
            '21:00',
            '21:20',
            '21:40'
          ]
        },
        {
          series: [
            '01일',
            '02일',
            '03일',
            '04일',
            '05일',
            '06일',
            '07일',
            '08일',
            '09일',
            '10일',
            '11일',
            '12일',
            '13일',
            '14일',
            '15일',
            '16일',
            '17일',
            '18일',
            '19일',
            '20일',
            '21일',
            '22일',
            '23일',
            '24일',
            '25일',
            '26일',
            '27일',
            '28일',
            '29일',
            '30일',
            '31일'
          ]
        },
        {
          series: [
            '1월',
            '2월',
            '3월',
            '4월',
            '5월',
            '6월',
            '7월',
            '8월',
            '9월',
            '10월',
            '11월',
            '12월'
          ]
        }
      ],
      bar: {
        xAxis: {
          type: 'category',
          data: ['a', 'b', 'c', 'd', 'e']
        },
        grid: {
          x: 45,
          y: 20,
          y2: 35,
          x2: 40
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: [1, 2, 3, 4, 5],
            type: 'bar'
          },
          {
            data: [1, 2, 3, 4, 5],
            type: 'line'
          }
        ],
        tooltip: {
          trigger: 'axis',
          formatter: ' {b0} <br /> {c0} kW'
        }
      },
      nowDate: day(Date.now()).format('YYYY-MM-DD'),
      essResult: [],
      dailyP: 0.0,
      isDailyP: true,
      toggleData: false,
      grid: {
        height: 0,
        gridOption: {
          gridView: {
            edit: {
              editable: false
            },
            setGroupingOptions: {
              enabled: false // header 그룹핑 옵션을 사용하지 않는다.
            },
            fixed: {
              rowCount: 1
            },
            checkBar: {
              visible: false
            },
            panel: {
              visible: false
            },
            display: {
              // 그리드 너비에 맞춰 컬럼 너비 자동 조정
              fitStyle: 'even'
            },
            rowIndicator: {
              visible: false
            },
            stateBar: {
              visible: false
            }
          },
          dataProvider: {
            softDeleting: true,
            // 해당 옵션이 false 이면 추가된 행을 삭제했을 경우 -+ 표시가 생긴다.
            // true 이면 추가된 행은 바로 삭제, 기존에 존재하던 행은 - 표시
            deleteCreated: true
          }
        },
        gridTotal: 0,
        gridFields: [
          { fieldName: 'runTime', dataType: 'string' },
          { fieldName: 'runData', dataType: 'string' }
        ],
        gridColumns: [
          {
            name: 'runTime',
            fieldName: 'runTime',
            header: {
              text: '시간'
            },
            styles: {
              textAlignment: 'center'
            },
            width: 50
          },
          {
            name: 'runData',
            fieldName: 'runData',
            header: {
              text: '발전량'
            },
            styles: {
              textAlignment: 'center',
              background: '#e0e8eb' // 수정 불가능 컬럼 배경색 회색
            }
          }
        ]
      }
    }
  },
  mounted() {
    this.initData()
  },
  computed: {
    searchType() {
      return this.tabs === 0 ? 'day' : this.tabs === 1 ? 'month' : 'year'
    },
    comboList() {
      let type =
        this.select2 === 'PVPCS'
          ? 'PVPCS'
          : this.select2 === 'EPCS'
            ? 'EPCS'
            : 'GRID'
      let all = {
        PVPCS: {
          text: '태양광 인버터 전체',
          value: 'PVPCS'
        },
        EPCS: {
          text: 'ESS PCS 전체',
          value: 'PVPCS'
        },
        GRID: {
          text: '계통 전체',
          value: 'GRID'
        }
      }
      let list = []
      list.push(all[type])
      for (let item of this.essResult) {
        if (item.photo === type) {
          list.push({
            text: item.description,
            value: item.codeid
          })
        }
      }
      return list
    },
    pCodeId() {
      let type =
        this.select2 === 'PVPCS'
          ? 'PVPCS'
          : this.select2 === 'EPCS'
            ? 'EPCS'
            : 'GRID'
      let allCheck =
        this.select === 'PVPCS' ||
        this.select === 'EPCS' ||
        this.select === 'GRID'
      let id = ''
      if (allCheck) {
        for (let item of this.essResult) {
          if (item.photo === type) {
            id = item.pcodeid
            break
          }
        }
      }
      return id
    },
    chartOption() {
      let a = this.bar
      a.xAxis.data = this.tabValue[this.tabs].series
      a.series[0].data = []
      a.series[1].data = []
      return a
    }
  },
  watch: {
    tabs() {
      this.toggleData = !this.toggleData
    },
    comboList() {
      this.select = this.comboList[0].value
      this.toggleData = !this.toggleData
    },
    toggleData() {
      this.getData()
    }
  },
  methods: {
    initData() {
      if (this.essData.result !== 'noData') {
        this.essResult = this.essData.essResult
      }
    },
    getData() {
      if (this.essData.essData.length > 0) {
        let params = {
          code_id: this.pCodeId || this.select,
          startDate: this.nowDate,
          searchType: this.searchType
        }
        getWorkTrend(params).then(response => {
          this.chartOption.xAxis.data = response.essTrend.runTime
          this.chartOption.series[0].data = response.essTrend.runData
          this.chartOption.series[1].data = response.essTrend.runData
          this.dailyP = response.essTrend.dailyP
          let datas = []
          for (
            let index = 0;
            index < response.essTrend.runTime.length;
            index++
          ) {
            datas.push({
              runTime: response.essTrend.runTime[index],
              runData: response.essTrend.runData[index]
            })
          }
          this.$refs.tempGrid.getDataProvider().fillJsonData(datas)
        })
      }
    },
    excelDown() {
      this.$refs.tempGrid.excelDown('Trend_' + this.nowDate)
    }
  }
}
</script>

<style lang="less" scoped>
.chart-header-bg {
  background-color: var(--v-hthline-base);
}
.excel_down {
  width: 100px;
  height: 30px;
  border: 1px solid #24943e;
  color: #24943e;
  text-align: center;
  line-height: 30px;
  font-weight: bold;
  cursor: pointer;
  box-sizing: border-box;
}

#realgrid {
  height: 0px;
  width: 100%;
  margin-top: 0;
  margin-bottom: 20px;
  margin-left: auto;
  margin-right: auto;
}
</style>
